// src/lib/supabase/client.ts - COM LOGS DE DEBUG
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./database.types";

/**
 * Configurações do cliente Supabase
 */
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Log para debug
console.log("Supabase Config:", {
  url: supabaseUrl ? "Configurado" : "Não configurado",
  key: supabaseAnonKey ? "Configurado" : "Não configurado",
  env: import.meta.env.MODE
});

// Validação das variáveis de ambiente com fallback
if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    "Variáveis de ambiente do Supabase não configuradas. " +
      "Verifique VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY no arquivo .env"
  );
}

// Falha rápida em produção quando variáveis estiverem ausentes
if (import.meta.env.PROD && (!supabaseUrl || !supabaseAnonKey)) {
  throw new Error(
    "Configuração do Supabase ausente em produção. " +
      "Defina VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY antes do deploy."
  );
}

// Cliente com fallback para desenvolvimento
export const supabase = createClient<Database>(
  supabaseUrl || "https://placeholder.supabase.co",
  supabaseAnonKey || "placeholder-anon-key",
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: "pkce",
      storage: localStorage,
    },
    db: {
      schema: "public",
    },
    global: {
      headers: {
        "X-Client-Info": "legal-dashboard@1.0.0",
      },
    },
  }
);